<template>
    <div class="youthBlindBox" :class="{ 'padding-top': userStore.isPadTop }">
        <div class="title re_relative re_flex_center re_font_18" :class="{ 'is-pad-top': userStore.isPadTop }">
            <van-icon @click="goBack()" class="icon" name="arrow-left" size="22" />
            <span>{{query.single && query.single == '1' ? '我的' : '青春'}}泡泡</span>
            <div class="right" @click="goRelease" v-if="query.single && query.single == '1'">
                <img src="../../../assets/blindBox/right.png" alt="">
                发布
            </div>
        </div>
        <div class="tabs">
            <div :class="{'active': active == 0}" @click="onClickTab(0)">我发出的</div>
            <div :class="{'active': active == 1}" @click="onClickTab(1)">我开启的</div>
        </div>
        <div class="content" ref="youthDetail"  @scroll="handleScroll">
            <div v-if="active == 0">
                <div class="content_item" v-for="(item, index) in sentoutList" :key="index" @click="goDetail(item)">
                    <div class="item_title">
                        <div>{{item.userIntroduce}}</div>
                        <div v-if="item.boxStatus == 2">展示中</div>
                        <div v-else-if="item.boxStatus == 1">审核中</div>
                        <div v-else-if="item.boxStatus == 3">已结束</div>
                        <div v-else-if="item.boxStatus == 0 || item.boxStatus == -1" class="item_error">审核失败</div>
                    </div>
                    <div class="item_create_time">
                        发放时间：{{item.createTime}}
                    </div>
                    
                    <div class="item_num">
                        发放数量：{{item.boxNum}}个
                    </div>
                    <div class="line" v-if="item.boxStatus == 2 || item.boxStatus == 3"></div>
                    <div class="item_img" v-if="item.boxStatus == 2 || item.boxStatus == 3">
                        <div>
                            <div v-for="(item1, index) in item.blindBoxJoinRecordVoList" :key="index">
                                <img :src="item1.joinUserPhoto" alt="">
                            </div>
                        </div>
                        <div> {{ item.joinRecordNum }} 人开启</div>
                    </div>
                </div>
                <div class="re_flex_center nolist" v-if="!sentoutList.length">
                    <div>
                        <img src="../../../assets/blindBox/nodate.png" alt="">
                    </div>
                    暂无数据
                </div>
            </div>
            <div v-if="active == 1">
                <div class="content_item content_item1" v-for="(item, index) in receivedList" :key="index" @click="goDetail(item)">
                    <div class="item_left">
                        <img :src="item.joinUserPhoto" alt="">
                        <img src="../../../assets/blindBox/heart.webp" class="heart" alt="">
                        <img :src="item.userPhoto" alt="">
                    </div>
                    <div class="item_right">
                        <div class="item_title"><div>{{item.userIntroduce}}</div></div>
                        <div class="item_create_time">开启时间：{{item.createTime}}</div>
                        <div class="item_gift">赠送礼物：{{item.boxGiftName}}</div>
                    </div>
                </div>
                <div class="re_flex_center nolist" v-if="!receivedList.length">
                    <div>
                        <img src="../../../assets/blindBox/nodate.png" alt="">
                    </div>
                    暂无数据
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useUserStore } from '../../stores/user';
import { router } from '../../router';
import { sentOutBlindBox, receivedBlindBox, selectMySendOutList, selectMyOpenList } from './api';
import { showToast } from 'vant';
import { useRoute } from 'vue-router';

export default {
    name: 'youthBlindBox',
    setup() {
        const userStore = useUserStore()
        const route = useRoute(); // 获取路由
        const query = ref(route.query); // 获取路由参数
        // 我发出的 0 我收到的 1
        const active = ref(0)
        const page = ref(1); // 页码
        const pageSize = ref(10); // 每页条数
        const pageFlag = ref(true); // 是否还有数据
        const loagFlag = ref(false); // 是否加载中
        // 返回
        const goBack = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                appJsImp.finish()
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage('finish')
            } 
        }
        // 发布泡泡
        const goRelease = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                appJsImp.goRelease()
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage('goRelease')
            } 
        }
        // 切花tab
        const onClickTab = (index) => {
            page.value = 1;
            pageFlag.value = true;
            active.value = index;
            if (index == 0) {
                sentoutList.value = []
                sentOut()
            } else {
                receivedList.value = []
                received()
            }
        };
        // 详情
        const goDetail = (item) => {
            console.log(query.value)
            let url = query.value.single && query.value.single == '1' ? '/youthBlindBox/singleDetail?boxId=' + item.boxId + '&active=' + active.value + (active.value == 1 ? '&boxRecordId=' + item.boxRecordId : '') : '/youthBlindBox/detail?boxId=' + item.boxId + '&active=' + active.value + (active.value == 1 ? '&boxRecordId=' + item.boxRecordId : '');
            router.push(url);
        }
        // 我发送的泡泡列表
        const sentoutList = ref([])
        // 我收到的泡泡列表
        const receivedList = ref([])
        // 发送泡泡
        const sentOut = () => {
            loagFlag.value = true
            if(query.value.single && query.value.single == '1') {
                //单身泡泡
                selectMySendOutList({ page: page.value, rows: pageSize.value }).then(res => {
                    loagFlag.value = false
                    if (res.code == 1) {
                        if (page.value == 1) {
                            sentoutList.value = res.rows
                        } else {
                            sentoutList.value = sentoutList.value.concat(res.rows)
                        }
                        if (res.rows.length < 10) {
                            pageFlag.value = false
                        } else {
                            page.value++
                            pageFlag.value = true
                        }
                    } else {
                        showToast(res.msg)
                    }
                })
                return;
            }
            // 青春泡泡
            sentOutBlindBox({ page: page.value, rows: pageSize.value }).then(res => {
                loagFlag.value = false
                if (res.code == 1) {
                    if (page.value == 1) {
                        sentoutList.value = res.data
                    } else {
                        sentoutList.value = sentoutList.value.concat(res.data)
                    }
                    if (res.data.length < 10) {
                        pageFlag.value = false
                    } else {
                        page.value++
                        pageFlag.value = true
                    }
                } else {
                    showToast(res.msg)
                }
            })
        }
        // 收到泡泡
        const received = () => {
            loagFlag.value = true
            if (query.value.single && query.value.single == '1') {
                // 单身泡泡
                selectMyOpenList({ page: page.value, rows: pageSize.value }).then(res => {
                    loagFlag.value = false
                    if (res.code == 1) {
                        if (page.value == 1) {
                            receivedList.value = res.rows
                        } else {
                            receivedList.value = receivedList.value.concat(res.rows)
                        }
                        console.log(res)
                        if (res.rows.length < 10) {
                            pageFlag.value = false
                        } else {
                            page.value++
                            pageFlag.value = true
                        }
                    } else {
                        showToast(res.msg)
                    }
                })
                return;
            }
            //青春泡泡
            receivedBlindBox({ page: page.value, rows: pageSize.value }).then(res => {
                loagFlag.value = false
                if (res.code == 1) {
                    if (page.value == 1) {
                        receivedList.value = res.data
                    } else {
                        receivedList.value = receivedList.value.concat(res.data)
                    }
                    
                    if (res.data.length < 10) {
                        pageFlag.value = false
                    } else {
                        page.value++
                        pageFlag.value = true
                    }
                } else {
                    showToast(res.msg)
                }
            })
        }
        const youthDetail = ref()
        const handleScroll = () => {
            const container = youthDetail.value
            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 4) {
                if(pageFlag.value) {
                    if(loagFlag.value) return
                    if (active.value == 0) {
                        sentOut()
                    } else {
                        received()
                    }
                }
            }
        }

        onMounted(() => {
            // 设置标题兼容ios高度
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if(isiOS){
                userStore.setIsPadTop(true)
            }
            // 详情返回事件监听
            active.value = Number(userStore.youthActive || 0)
            if (active.value == 0) {
                sentOut();
            } else  {
                received();
            }

            window.refreshBlindBox = () => {
                setTimeout(() => {
                    active.value = 0;
                    sentOut();
                }, 500);
            }
            
        })
        return {
            userStore,active,sentoutList,receivedList,query,youthDetail,
            goBack,onClickTab,goDetail,handleScroll,goRelease
        }
    }
}
</script>
<style lang="less" scoped>
.youthBlindBox {
    padding: 0px 16px 0;
    // background: #fff;
    background: url(../../../assets/blindBox/bg.webp) no-repeat;
    background-size: 100% 115%;
    height: calc(100vh);
    // overflow-y: auto;
    overflow: hidden;
    .title {
        padding: 48px 0 18px 0;
        width: 100%;
        font-weight: 600;
        .icon {
            position: absolute;
            left: 16px;
            bottom: 18px;
            margin-left: -16px;
            padding: 0 24px 0 0;
        }
        .right {
            position: absolute;
            right: 0px;
            bottom: 18px;
            color: #FFFFFF;
            height: 24px;
            background: #FF4EBD;
            padding: 0 10px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 15px;
                height: 14px;
                margin-right: 4px;
            }
        }
    }
    .is-pad-top {
        padding-top: 56px;
    }
    .tabs {
        display: flex;
        user-select: none;
        box-sizing: content-box;
        padding-bottom: 5px;
        border-color: rgb(255, 62, 201);
        background: unset;
        margin-bottom: 18px;
        font-size: 14px;
        width: calc(100vw - 32px);
        div {
            position: relative;
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 var(--van-padding-base);
            color: var(--van-tab-text-color);
            font-size: var(--van-tab-font-size);
            line-height: var(--van-tab-line-height);
            cursor: pointer;
            line-height: 20px;
        }
        .active {
            color: rgb(255, 62, 201);
            font-weight: 600;
        }
        .active::after {
            content: '';
            display: block;
            width: 12px; /* 设置边框长度 */
            height: 3px; /* 设置边框高度 */
            background-color: rgb(255, 62, 201); /* 设置边框颜色 */
            position: absolute;
            left: 50%;
            bottom: -5px;
            transform: translateX(-50%);
            border-radius: 2px;
        }
    }
    .content {
        width: 100%;
        height: calc(100vh - 160px);
        overflow-y: auto;
    }
    .content_item {
        padding: 16px;
        // width: 100%;
        // height: 112px;
        background-image: linear-gradient(125deg, #FF95D3 0%, #FF44BA 100%), linear-gradient(146deg, #FF5BA5 0%, #FF3F6B 95%);
        border-radius: 8px;
        font-weight: 400;
        color: #FFFFFF;
        font-size: 12px;
        margin-bottom: 8px;
        .item_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            width: 100%;
            >div:nth-child(1) {
                font-weight: 500;
                font-size: 16px;
                color: #FFFFFF;
                width: calc(100% - 60px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            >div:nth-child(2) {
                text-align: right;
                min-width: 48px;
                &.item_error {
                    color: #FFEAA1;
                }
            }
        }
        .item_create_time {
            margin-bottom: 8px;
        }
        .item_num {
            margin-bottom: 8px;
        }
        .line {
            width: 100%;
            height: 1px;
            background: #ffffff29
        }
        .item_img {
            display: flex;
            justify-content: left;
            align-items: center;
            margin-top: 13px;
            >div:nth-child(1) {
                div {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    margin-left: -6px;
                    border-radius: 50%;
                    border: #fff 1px solid;
                    
                }
                div:nth-child(1) {
                    margin-left: 0px;
                }
                img {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                }
            }
            >div:nth-child(2) {
                margin-left: 8px;
            }
        }
        
    }
    .content_item1 {
        display: flex;
        .item_left {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 8px;
            width: 100px;
            img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
            .heart {
                width: 28px;
                height: 16px;
                border-radius: 0;
            }
        }
        .item_right {
            width: calc(100% - 108px);
            .item_title {
                font-size: 16px;
                width: 100%;
                div {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .nolist {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40%;
        color: #666;
        flex-wrap: wrap;
        font-size: 16px;
        div {
            width: 100%;
            text-align: center;
            margin-bottom: 20px;
            img {
                width: 120px;
                height: 125px;
            }
        }
    }
}
</style>